(function($){
  if ( $('.custom-mobile-collapsable-section').length) {
    
    var accordionHeadings = $('.custom-mobile-collapsable-section .accordion-heading');
    accordionHeadings.each(function(index, el){
      $(el).on('click', function(){
          if ( $( window ).width() < 650) {
            $(this).next().slideToggle('fast');
            $(this).toggleClass('ow-accordion-open');
          }
      });

      if ( index == 0){
        if ( $( window ).width() < 650) {
          $(el).next().slideToggle('fast');
          $(el).toggleClass('ow-accordion-open');
        }
      }
    });
  }
})(jQuery);